__webpack_require__.p = "/bizx-dine/mandi-darbar/";